// extracted by mini-css-extract-plugin
export default {"wrapper":"Wx-z","button":"Xx-z","alternate":"Yx-z","disabled":"Zx-z","paymentWarning":"_x-z","fadeIn":"ay-z"};